var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#2B2826"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -4.19999,
    y: -4.20024,
    width: 48.4,
    height: 47.4002
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6.4px)",
      clipPath: "url(#bgblur_0_10891_67350_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10891_67350)",
    "data-figma-bg-blur-radius": 12.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6415 9.35207C20.5976 8.88232 19.4024 8.88232 18.3585 9.35207L10.7689 12.7674C9.69235 13.2519 9 14.3226 9 15.5032V17C9 17.5523 9.44772 18 10 18H11.5V24.8368C10.3175 25.3986 9.50003 26.6038 9.50003 28V29C9.50003 29.5523 9.94775 30 10.5 30H29.5C30.0523 30 30.5 29.5523 30.5 29V28C30.5 26.6038 29.6825 25.3985 28.5 24.8368V18H30C30.5523 18 31 17.5523 31 17V15.5032C31 14.3226 30.3076 13.2519 29.2311 12.7674L21.6415 9.35207ZM24.5 18H26.5V24.5H24.5V18ZM17.5 18H22.5V24.5H17.5V18ZM13.5 18H15.5V24.5H13.5V18Z",
    fill: "url(#paint0_linear_10891_67350)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2764 9.16968C19.3725 8.67644 20.6275 8.67644 21.7236 9.16968L29.3135 12.5847C30.4616 13.1014 31.2 14.2437 31.2002 15.5027V16.9998C31.2002 17.6625 30.6627 18.2 30 18.2H28.7002V24.7146C29.8874 25.3302 30.7001 26.5693 30.7002 27.9998V28.9998C30.7002 29.6625 30.1627 30.2 29.5 30.2H10.5C9.83727 30.1999 9.2998 29.6625 9.2998 28.9998V27.9998C9.2999 26.5693 10.1126 25.3302 11.2998 24.7146V18.2H10C9.33726 18.2 8.7998 17.6625 8.7998 16.9998V15.5027C8.79999 14.2437 9.53843 13.1014 10.6865 12.5847L18.2764 9.16968ZM24.7002 24.2996H26.2998V18.2H24.7002V24.2996ZM17.7002 24.2996H22.2998V18.2H17.7002V24.2996ZM13.7002 24.2996H15.2998V18.2H13.7002V24.2996Z",
    stroke: "#C58000",
    strokeOpacity: 0.48,
    strokeWidth: 0.4,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10891_67350",
    x: -4.19999,
    y: -4.20024,
    width: 48.4,
    height: 47.4002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.899346 0 0 0 0 0.713726 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10891_67350"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10891_67350",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_10891_67350_clip_path",
    transform: "translate(4.19999 4.20024)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6415 9.35207C20.5976 8.88232 19.4024 8.88232 18.3585 9.35207L10.7689 12.7674C9.69235 13.2519 9 14.3226 9 15.5032V17C9 17.5523 9.44772 18 10 18H11.5V24.8368C10.3175 25.3986 9.50003 26.6038 9.50003 28V29C9.50003 29.5523 9.94775 30 10.5 30H29.5C30.0523 30 30.5 29.5523 30.5 29V28C30.5 26.6038 29.6825 25.3985 28.5 24.8368V18H30C30.5523 18 31 17.5523 31 17V15.5032C31 14.3226 30.3076 13.2519 29.2311 12.7674L21.6415 9.35207ZM24.5 18H26.5V24.5H24.5V18ZM17.5 18H22.5V24.5H17.5V18ZM13.5 18H15.5V24.5H13.5V18Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10891_67350",
    x1: 20,
    y1: 21.6043,
    x2: 20,
    y2: 27.3555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFBAA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.ce84b2b4eb044faa9ccbe89b9ae9adc3.svg";
export { ForwardRef as ReactComponent };